import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export interface HousingUnitsRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  housing_units_per_1000_residents: number;
}

export function useHousingUnitsPer1kData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<HousingUnitsRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false);
      setData([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_metrics_housing_availability')
      .select('Place, place_fips, year, housing_units_per_1000_residents')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .order('year', { ascending: true })
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching housing units data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          setData(supabaseData || []);
          // Log the latest record for the selected city
          const latest = (supabaseData || []).slice(-1)[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  Housing Units per 1k: ${latest.housing_units_per_1000_residents?.toFixed(2)}`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 